import { addFileWidget } from './actions';
const addFileAction = 'addFile';
export const YfmFileWidget = (builder, opts) => {
    builder.addAction(addFileAction, (deps) => addFileWidget(deps, opts.fileUploadHandler));
};
